const getShipping = (state)=>state.shipping
;

export { getShipping };
//# sourceMappingURL=selectors.internal.js.map
